import { useTranslations } from "use-intl";

import { UnreadEmailIcon } from "@/components/appIcons";
import { Button } from "@/components/ui/button";

export function EmailVerificationBannerContent({
  email,
  onDismiss,
  onResend,
  resending,
  resent,
}: {
  email: string;
  onDismiss: () => void;
  onResend: () => void;
  resending: boolean;
  resent: boolean;
}) {
  const t = useTranslations("globals.auth");
  return (
    <div className="relative z-40 border-b border-amber-500/30 bg-amber-950/20 text-amber-100">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-3 px-4 py-3 md:flex-row md:items-center md:justify-between md:px-10 lg:px-20">
        <div className="flex min-w-0 items-start gap-3">
          <UnreadEmailIcon className="mt-0.5 text-xl" />
          <div className="min-w-0 space-y-0.5">
            <p className="text-sm font-semibold">{t("verifyEmailBannerTitle")}</p>
            <p className="text-xs leading-5 text-amber-100/80">
              {t("verifyEmailBannerDescription", { email })}
            </p>
            {resent && (
              <p className="text-xs font-medium text-amber-50">{t("verificationResent")}</p>
            )}
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2 self-end md:self-auto">
          <Button
            size="sm"
            variant="outline"
            onClick={onResend}
            disabled={resending}
            className="border-amber-400/40 bg-amber-950/40 hover:bg-amber-950/70"
          >
            {resending ? t("submitting") : t("verifyEmailBannerResend")}
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={onDismiss}
            className="text-amber-100 hover:bg-amber-900/40"
          >
            {t("verifyEmailBannerDismiss")}
          </Button>
        </div>
      </div>
    </div>
  );
}
